import { Controller } from "@hotwired/stimulus"
import confetti from "canvas-confetti"
import { triggerHaptic } from "../src/trigger_native_haptic"

// Entry animation for the first plan's separately navigated branch screens.
export default class extends Controller {
  static targets = ["content", "success", "completionAction"]

  connect() {
    this.animations = []
    this.beforeCache = () => this.finish()
    document.addEventListener("turbo:before-cache", this.beforeCache)
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    if (this.hasSuccessTarget && !this.successTarget.hasAttribute("data-celebrated")) {
      this.successTarget.setAttribute("data-celebrated", "true")
      triggerHaptic()
      if (this.successTarget.dataset.complete === "true") {
        confetti({ particleCount: 70, spread: 65, origin: { y: 0.6 }, disableForReducedMotion: true })
      }
    }
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    const bubbles = Array.from(this.element.querySelectorAll("[data-first-plan-bubble]"))
    bubbles.forEach((bubble, index) => this.reveal(bubble, index * 700))

    const blocks = this.contentTargets.flatMap((container) => Array.from(container.children))
      .filter((element) => !element.querySelector("[data-first-plan-bubble]"))
      .flatMap((element) => element.hasAttribute("data-first-plan-reveal-group") ? Array.from(element.children) : [element])
    const delay = bubbles.length ? (bubbles.length - 1) * 700 + 700 : 0
    blocks.forEach((block, index) => this.reveal(block, delay + index * 70))
  }

  productAdded() {
    if (!this.hasCompletionActionTarget) return

    this.completionActionTarget.querySelector('[data-loading-button-target="text"]').textContent = "Done"
  }

  dismiss(event) {
    // The drawer handles the bubbling click locally; standalone pages follow the link.
    if (this.element.closest(".bottom-drawer")) event.preventDefault()
  }

  reveal(element, delay) {
    const wasInert = element.inert
    element.inert = true
    const animation = element.animate([
      { opacity: 0, transform: "translateY(8px)" },
      { opacity: 1, transform: "translateY(0)" }
    ], { duration: 250, delay, easing: "ease-out", fill: "backwards" })
    const restore = () => { element.inert = wasInert }
    animation.finished.then(restore, restore)
    this.animations.push({ animation, restore })
  }

  finish() {
    this.animations.forEach(({ animation, restore }) => {
      animation.cancel()
      restore()
    })
    this.animations = []
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
    this.finish()
  }
}
